import { useMessageContext } from 'stream-chat-react';
import { makeStyles } from '@material-ui/styles';
import { TextButton, Theme } from '@bizzabo/design-system';
import useTypeTracking from '../../analytics';

const ReplyButton = ({ title }) => {
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();

    const { handleOpenThread, message } = useMessageContext();

    const handleReplyClick = e => {
        handleOpenThread(e);
        trackClickEvent({
            buttonType: title,
            subCategory: 'REPLY',
        });
    };

    const getReplayBtnText = (count: number): string => {
        const text = count > 1 ? 'Replies' : 'Reply';
        return !count ? text : `${count} ${text}`;
    };

    return (
        <TextButton className={classes.replyBtn} onClick={handleReplyClick}>
            {getReplayBtnText(message.reply_count)}
        </TextButton>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        replyBtn: {
            ...theme.typography.t81,
            paddingBottom: 0,
            color: theme.palette.greys[500],
            borderBottomColor: theme.palette.greys[500],
            '&:hover': {
                color: theme.palette.greys[700],
                borderBottomColor: theme.palette.greys[700],
            },
        },
    }),
    {
        classNamePrefix: 'ReplyButton',
    }
);

export default ReplyButton;
